// extracted by css-extract-rspack-plugin
export default {"cls1":"LoswpPackPitch-cls1_y97","cls2":"LoswpPackPitch-cls2_WBC LoswpPackPitch-cls1_y97"};